import { getDistance } from 'geolib'

const getDistanceAndWalkTime = ({ myLat, myLng, item, t }) => {
  let distance = '',
    walkTime = ''
  if (!!myLat && !!myLng) {
    distance = getDistance(
      {
        latitude: myLat,
        longitude: myLng,
      },
      {
        latitude: item.getIn(['place', 'lat']),
        longitude: item.getIn(['place', 'lng']),
      },
    )
    if (distance >= 10000) {
      walkTime = ''
    } else if (distance / 40 < 2) {
      walkTime = t('小於2')
    } else if (distance < 2000) {
      walkTime = Math.round(distance / 40)
    }
    if (distance >= 10000) {
      distance = t('超過10公里，在遠的要命王國')
    } else if (distance >= 1000) {
      distance = t('距離你{{distance}}公里', {
        distance: Math.round((distance / 1000) * 100) / 100,
      })
    } else {
      distance = t('距離你{{distance}}公尺', { distance })
    }
  }
  return { distance, walkTime }
}

export default getDistanceAndWalkTime
